<script>
import CheckboxListField from '@phoenix/mixins/components/form/fields/CheckboxListField';
import { useField } from '@phoenix/composables/field';

export default {
  mixins: [CheckboxListField],

  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    return useField(props);
  },

  computed: {
    ulClasses() {
      return {
        'sgphx-checkboxes-inline__list': this.isSgphx && this.inline,
        'checkboxes-inline__list': !this.isSgphx && this.inline,
      };
    },
  },
};
</script>

<template>
  <ul :aria-labelledby="ariaLabelledby" :class="ulClasses">
    <li v-for="option in field.options" :key="option.id">
      <checkbox-list-item-field
        v-model="value"
        :parent-id="field.id"
        :attrs="option"
        :should-validate="false"
        :is-sgphx="isSgphx"
      />
    </li>
  </ul>
</template>
